import { useEffect } from 'react';
import { setGraphqlUrl } from '@/api/graphqlClient';
import { setUsfmServiceUrl } from '@/api/usfmService';

export function useAppConfig() {
  useEffect(() => {
    async function fetchAppConfig() {
      try {
        const response = await fetch('/config/app-config');
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        const data = await response.json();

        if (typeof data.graphqlUrl === 'string' && data.graphqlUrl.trim() !== '') {
          setGraphqlUrl(data.graphqlUrl);
        }

        // This is required for USFM import/export actions. If it's missing, an error will be thrown when one of those actions is triggered.
        if (typeof data.usfmServiceUrl === 'string' && data.usfmServiceUrl.trim() !== '') {
          setUsfmServiceUrl(data.usfmServiceUrl);
        }
      } catch (error) {
        console.error('Failed to fetch app config:', error);
      }
    }

    fetchAppConfig();
  }, []);
}
